import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { BadgeComponent, type BadgeColor } from '@core/user-interface-legacy';

import type { ProductCategory, UpdateCategory } from '../../models/product-update.model';

export type BadgeVariant = 'default' | 'ghost';

@Component({
  selector: 'pu-category-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeComponent],
  host: {
    '[class.badge--ghost]': 'variant() === "ghost"',
  },
  templateUrl: './category-badge.component.html',
  styleUrls: ['./category-badge.component.less'],
})
export class CategoryBadgeComponent {
  private readonly translationService = inject(I18nService);

  public readonly category = input.required<ProductCategory | UpdateCategory>();
  public readonly type = input<'product' | 'update'>('product');
  public readonly variant = input<BadgeVariant>('default');

  public readonly badgeColor = computed<BadgeColor>(() => {
    const category = this.category();
    if (category === 'New') {
      return 'primary';
    }
    return 'primary-low';
  });

  public readonly label = computed(() => {
    const category = this.category();
    const key = this.getTranslationKey(category);
    return key ? this.translationService.translate(key) : category;
  });

  private getTranslationKey(category: ProductCategory | UpdateCategory): string | null {
    const keyMap: Record<string, string> = {
      Hire: 'filters.hire',
      Manage: 'filters.manage',
      Grow: 'filters.grow',
      Platform: 'filters.platform',
      Feature: 'categories.feature',
      Improvement: 'categories.improvement',
      Changelog: 'categories.changelog',
      New: 'categories.new',
      'Coming soon': 'categories.coming_soon',
    };
    return keyMap[category] ?? null;
  }
}
